// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"ruG0bQnGUtqCFC7OInatb"};